import React from 'react';
import { Wine, Instagram, MapPin, Phone, MessageCircle } from 'lucide-react';
import { businessData } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[var(--color-wine)] text-[var(--color-cream)]">
      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-4 py-12 md:py-16">
        <div className="grid md:grid-cols-3 gap-10">
          {/* Logo and Description */}
          <div className="md:col-span-1">
            <img
              src={businessData.logo}
              alt={`${businessData.name} - ${businessData.tagline}`}
              className="h-20 w-auto rounded mb-4"
            />
            <p className="text-[var(--color-cream)]/70 leading-relaxed">
              Tu vinoteca de confianza en Santa Fe. Amplia selección de vinos, destilados y productos premium.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4 flex items-center gap-2">
              <Wine size={18} />
              Enlaces rápidos
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="#inicio"
                  className="text-[var(--color-cream)]/70 hover:text-[var(--color-gold)] transition-colors"
                >
                  Inicio
                </a>
              </li>
              <li>
                <a
                  href="#productos"
                  className="text-[var(--color-cream)]/70 hover:text-[var(--color-gold)] transition-colors"
                >
                  Productos
                </a>
              </li>
              <li>
                <a
                  href="#opiniones"
                  className="text-[var(--color-cream)]/70 hover:text-[var(--color-gold)] transition-colors"
                >
                  Opiniones
                </a>
              </li>
              <li>
                <a
                  href="#contacto"
                  className="text-[var(--color-cream)]/70 hover:text-[var(--color-gold)] transition-colors"
                >
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contacto</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={businessData.googleMapsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 text-[var(--color-cream)]/70 hover:text-[var(--color-gold)] transition-colors"
                >
                  <MapPin size={18} className="flex-shrink-0 mt-1" />
                  <span className="text-sm">{businessData.address}</span>
                </a>
              </li>
              <li>
                <a
                  href={`tel:${businessData.phone}`}
                  className="flex items-center gap-3 text-[var(--color-cream)]/70 hover:text-[var(--color-gold)] transition-colors"
                >
                  <Phone size={18} />
                  <span>{businessData.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={businessData.whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-[var(--color-cream)]/70 hover:text-[var(--color-gold)] transition-colors"
                >
                  <MessageCircle size={18} />
                  <span>WhatsApp</span>
                </a>
              </li>
              <li>
                <a
                  href={businessData.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-[var(--color-cream)]/70 hover:text-[var(--color-gold)] transition-colors"
                >
                  <Instagram size={18} />
                  <span>@indiana.vinoteca</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[var(--color-wine-light)]">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <p className="text-center text-sm text-[var(--color-cream)]/60">
            © {currentYear} Indiana · Desarrollado por{' '}
            <a
              href="https://www.somosappolo.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[var(--color-gold)] hover:text-[var(--color-gold-light)] transition-colors"
            >
              Appolo
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
